<template>
  <div>
    <panel Title=" لیست اقساط" Des="از طریق این فرم می توانید لیست اقساط خود را مدیریت کتید" :IsBtnBack="true" :IsBtnClose="false" ClassCustom="bg-dark-Custom text-right"></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-list"></i> لیست اقساط</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12 text-left">
            <vue-bootstrap4-table v-if="$store.state.renderComponent" :rows="rows" :columns="columns" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mablaghSharj" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghSharj) }}
                </p>
              </template>

              <template slot="SumGhabelPar" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.SumGhabelPar) }}
                </p>
              </template>
              <template slot="nameFamily" slot-scope="props">
                <p class="text-center">
                  {{ props.row.nameFamily != null ? props.row.nameFamily : 'خودم' }}
                </p>
              </template>
              <template slot="Action" slot-scope="props">
                <small class="">
                  <div class="btn Pointer btn-outline-danger" @click="Delete(props.row.id)"><i class="fas fa-trash ml-2"></i> حذف از لیست پرداخت</div>
                </small>
              </template>
            </vue-bootstrap4-table>
            <div class="btn Pointer btn-danger rounded ml-5 mt-2" @click="DeleteAllItemsCart()"><i class="fas fa-trash ml-2"></i> حذف تمامی موارد داخل لیست</div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card :Classes="'bg-dark-Custom'">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-users ml-2"></i>اطلاعات تکمیلی و انتخاب درگاه</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12 col-md-5 text-center">
            <div class="border-bottom border-warning pb-2">
              <b style="font-size: 15px !important" class="text-dark">اطلاعات نهـــایی</b>
            </div>
            <div class="">
              <div class="alert bg-dark-Custom text-center w-100 mt-2">
                <b class="text-warning" style="font-size: 15px !important">اطلاعات نهایی ، </b>
                <span class="text-light">پس از اطمینان از مبلغ ، روی دکمه واریز کلیک کنید</span>
              </div>
            </div>
            <div class="mt-3">
              <b style="font-size: 15px !important" class="text-dark">جمع مبالغ لیست اقساط شما </b>
            </div>
            <div class="mt-3">
              <b style="font-size: 30px !important" class="text-dark border-bottom border-warning">{{ $Comma3ragham(GetSumCart()) }} </b>
              <small style="font-size: 15px !important" class="text-dark d-block mt-3">{{ Mab2persian }} </small>
            </div>
          </div>
          <div class="col-12 col-md-7 text-center mt-5 mt-md-0">
            <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
              <template v-slot:ContentButtonPayment>
                <button :disabled="GetSumCart() < 10000" class="btn btn-success w-50" @click="Payment">پرداخت {{ $Comma3ragham(GetSumCart()) }}</button>
              </template>
            </payment>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Num2persian from 'num2persian'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import Payment from './Payment.vue'
export default {
  components: { Panel, NetPaCard, Payment },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'دسته بندی',
          name: 'Catrgory',
        },
        {
          label: 'نوع ',
          name: 'desNoe',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'شماره حساب | تسهیلات',
          name: 'vCode',
        },

        {
          label: 'مبلغ قابل پرداخت',
          name: 'SumGhabelPar',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      GatewayCode: null,
      FixVariz: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
    }
  },
  methods: {
    GetList() {
      let list = this.$store.state.Netpa_Cart

      if (list.length == 0) {
        this.rows = []
        // this.$router.push({name:'DepositGroup'})
      } else {
        this.rows = []
        for (let index = 0; index < list.length; index++) {
          for (let jndex = 0; jndex < list[index].item.length; jndex++) {
            list[index].item[jndex].Catrgory = list[index].lbl
            this.rows.push(list[index].item[jndex])
          }
        }
        this.GetSumCart()
      }
    },
    Delete(id) {
      let list = this.$store.state.Netpa_Cart
      for (let index = 0; index < list.length; index++) {
        if (list[index].item.length > 0) {
          for (let jndex = 0; jndex < list[index].item.length; jndex++) {
            if (list[index].item[jndex].id == id) {
              if (list[index].item.length > 1) {
                list[index].item.splice(jndex, 1)
                this.GetList()
                return
              } else {
                list.splice(index, 1)
                if (list.length < 1) {
                  this.$store.state.Netpa_Cart = []
                  this.$router.go(-1)
                }
                this.GetList()
                return
              }
            }
          }
        }
      }
    },
    GetSumCart() {
      var Sum = 0
      for (let index = 0; index < this.rows.length; index++) {
        Sum += Number((this.rows[index].SumGhabelPar + '').replace(/,/g, ''))
      }
      return Sum
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    FixVarizGhest(val) {
      this.FixVariz = val
    },
    Payment() {
      if (this.GatewayCode == 0) {
        if (this.$session.get('CustCode') == 801) {
          this.$swal(
            'اختلال در پرداخت با درگاه',
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)" ,
            'warning'
          )
        } else {
          this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
        }
      } else {
        const WwwtblVarizGorohiRiz = []
        for (let index = 0; index < this.rows.length; index++) {
          if (this.rows[index].ListTaahodatRiz && this.rows[index].ListTaahodatRiz.length > 0) {
            //تعهدات ریز دارد
            for (let Jndex = 0; Jndex < this.rows[index].ListTaahodatRiz.length; Jndex++) {
              WwwtblVarizGorohiRiz.push({
                WwwtblTaahodatId: this.rows[index].id,
                Mablagh: this.rows[index].ListTaahodatRiz[Jndex].mablaghGhest + (this.rows[index].ListTaahodatRiz[Jndex].mabJarime - this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh),
                SharhRiz:
                  ' پرداخت گروهی (قسط شماره ' + this.rows[index].ListTaahodatRiz[Jndex].shomareGhest + ') _ ' + this.rows[index].vCode + ' ___ ' + 'مبلغ بخشش: ' + this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh + ' ___ ' + 'مبلغ جریمه :' + this.rows[index].ListTaahodatRiz[Jndex].mabJarime,
                WwwtblAzaId: this.rows[index].wwwtblAzaId,
                BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
                BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
                MablaghJarime: this.rows[index].ListTaahodatRiz[Jndex].mabJarime - this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh,
                TarixGhest: this.rows[index].ListTaahodatRiz[Jndex].tarixGhest,
                IsTaahodatRiz: true,
              })
            }
          } else {
            //تعهدات ریز ندارد و خود تسهیلات مستقیم انتخاب شده
            WwwtblVarizGorohiRiz.push({
              WwwtblTaahodatId: this.rows[index].id,
              Mablagh: this.rows[index].SumGhabelPar,
              SharhRiz: ' پرداخت گروهی  ' + this.rows[index].vCode,
              WwwtblAzaId: this.rows[index].wwwtblAzaId,
              BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
              BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
              MablaghJarime: this.rows[index].wwwJarime,
              TarixGhest: this.rows[index].minTarGhestBedehkar,
              IsTaahodatRiz: false,
            })
          }
        }

        // const WwwtblVarizGorohiRiz = [];
        // for (let index = 0; index < this.rows.length; index++) {
        //   WwwtblVarizGorohiRiz.push({
        //     WwwtblTaahodatId: this.rows[index].id,
        //     Mablagh: this.rows[index].SumGhabelPar,
        //     SharhRiz: " پرداخت گروهی  " + this.rows[index].vCode,
        //     WwwtblAzaId: this.rows[index].wwwtblAzaId,
        //     BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
        //     BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
        //     MablaghJarime: this.rows[index].wwwJarime,
        //     TarixGhest: this.rows[index].minTarGhestBedehkar,
        //   });
        // }

        this.DataAxios_Variz.ArryfildValue.Mablagh = this.GetSumCart()
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
        this.DataAxios_Variz.ArryfildValue.Sharh = 'پرداخت گروهی'
        this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('UserInfoNetPa').custCode)
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.$session.get('UserInfoNetPa').wwwtblAzaId
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === 'Success') {
            if (this.GatewayCode == 0) {
              if (this.$session.get('CustCode') == 801) {
                this.$swal(
                  'اختلال در پرداخت با درگاه',
                  "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)" ,
                  'warning'
                )
              } else {
                this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
              }
            } else {
              this.$Payment(
                this.GatewayCode + '',
                JSON.stringify(this.GetSumCart()),
                this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily,
                this.$session.get('UserInfoNetPa').email,
                this.$session.get('UserInfoNetPa').mobile,
                WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
                '',
                this.rows[0].vCode,
                'سبد اقساط',
                JSON.stringify(this.$session.get('UserInfoNetPa').wwwtblAzaId),
                this.$session.get('UserInfoNetPa').custCode,
                JSON.stringify(this.$session.get('UserInfoNetPa').wwwtblShobeId),
                result.idRepoMaster,
                this.$session.get('UserInfoNetPa').codeMeli,
                this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily,
                this.$session.get('UserInfoNetPa').mobile,
                this.$session.get('UserInfoNetPa').codeMeli,
              )
            }
          } else {
            this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
            this.DeleteAllItemsCart()
          }
        })
      }
    },
    DeleteAllItemsCart() {
      this.$store.state.Netpa_Cart = []
      this.GetList()
      this.$router.go(-1)
    },
  },
  mounted() {
    this.GetList()
  },
  computed: {
    GetSumList() {
      // let SumMab=0;
      let list = this.$store.state.Netpa_Cart
      for (let index = 0; index < list.length; index++) {
        for (let jndex = 0; jndex < list[index].item.length; jndex++) {
          if (list[index].item[jndex].Catrgory == 'حساب ها') {
            //     SumMab+=list[index].item[jndex]
            //   console.log(SumMab);
          }
        }
      }
      return 2
    },
    Mab2persian() {
      var Mab = this.GetSumCart()
      // Mab=Mab/10
      return Num2persian(Mab) + ' ریال '
    },
  },
}
</script>
<style scoped>
.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}
</style>
